var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-server-table',{attrs:{"url":("fundsfiles/" + _vm.id + "/"),"columns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"gross_amount",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(Number(row.gross_amount).toFixed(2))+" ")]}},{key:"net_amount",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(Number(row.net_amount).toFixed(2))+" ")]}},{key:"tax_deductions_pct",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.getValue(row.tax_deductions_pct))+" ")]}},{key:"other_deductions_pct",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.getValue(row.other_deductions_pct))+" ")]}},{key:"additions_pct",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.getValue(row.additions_pct))+" ")]}},{key:"actions",fn:function(ref){
var row = ref.row;
return [_c('span',{staticClass:"ml-3",on:{"click":function($event){return _vm.goToFile(row)}}},[_c('i',{staticClass:"fas fa-level-up-alt rotate-90"})])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }